import * as React from "react";
const IconHamburger = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.98633 5.99243H21.9863M3.98633 11.9924H21.9863M3.98633 17.9924H21.9863"
      stroke="#1C1C2C"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default IconHamburger;
